let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k3S9d")).then(() => parcelRequire('lS60U'));